<template>
  <div class="page">
    <Head2></Head2>
    <div class="prompt">
      <div class="promptInner">
        <img src="../assets/images/speaker.png" class="speakerIcon" />
        <div>{{ $t("components.index.prompt_title") }}</div>
        <div class="promptLink">{{ $t("components.index.prompt_link") }}</div>
      </div>
    </div>
    <div class="bannerArea">
      <div class="bannerRelative">
        <div class="bannerInnerLeft">
          <router-link to="/category">
            <div class="bannerLeftTitle">
              {{ $t("components.index.banner_all_categories") }}
            </div>
          </router-link>
          <div>
            <div class="bannerLeftLi" v-for="(item, index) in categoryList" :key="item.id" @click="showMenu(item.id)">
              <img src="../assets/images/dotIcon.png" class="dotIcon" />
              <img src="../assets/images/dotIcon_active.png" class="dotActive" />
              <router-link :to="{ path: '/category', query: { id: item.id } }">
                <div>{{ item.name }}</div>
              </router-link>
            </div>
          </div>
        </div>
        <div class="bannerInnerMiddle" @click="hideMenu" v-if="isShowMenu">
          <div class="menuList" v-for="(item, index) in childcategoryList" :key="item.id">
            <div class="secondMenu">
              <router-link :to="{ path: '/category', query: { id: item.id } }">
                <span>{{ item.name }}</span>
              </router-link>
              <img src="../assets/images/rightArrowGray.png" />
            </div>
            <ul>
              <li v-for="(child, indexchild) in item.child_list">
                <router-link :to="{ path: '/category', query: { id: child.id } }">
                  <div>{{ child.name }}</div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="bannerRight">
          <div class="rightTitle" v-if="isLogin">
            {{ loginMember.enterprise }}
          </div>
          <div class="bannerInnerRight">
            <div class="userInfoArea" v-if="!isLogin">
              <div class="welcomeArea">
                <img src="../assets/images/head.png" class="headIcon" />
                <div>
                  <div>{{ $t("components.index.welcome_hello") }}</div>
                  <div>{{ $t("components.index.welcome_line2") }}</div>
                </div>
              </div>
              <div class="loginText">
                <router-link to="/login"><span>{{ $t("components.index.login") }}</span></router-link>
                {{ $t("components.index.enjoy_discount") }}
              </div>
              <div class="loginBtns">
                <router-link to="/register">
                  <div class="registerBtn">
                    {{ $t("components.index.register_btn") }}
                  </div>
                </router-link>
                <router-link to="/login">
                  <div class="loginBtn">
                    {{ $t("components.index.login") }}
                  </div>
                </router-link>
              </div>
            </div>

            <div class="userInfoArea" v-if="isLogin">
              <div class="welcomeText">
                {{ $t("components.index.welcome_banner") }}
              </div>
              <div class="welcomeArea">
                <img src="../assets/images/head.png" class="headIcon" />
                <div>
                  <div class="info_phone">{{ loginMember.phone_number }}</div>
                  <div class="info_name">
                    {{ $t("components.index.hello_prefix")
                    }}{{ loginMember.nick_name }}
                  </div>
                </div>
              </div>
              <div class="safe">
                <img src="../assets/images/an.png" class="safeIcon" />
                <div>
                  <span>{{ $t("components.index.account_security") }}</span><span class="edit"><router-link :to="{
                    path: '/my',
                    query: { type: 'MYINFO', act: 'editPsd' },
                  }">{{ $t("components.index.change_password") }}</router-link></span>
                </div>
              </div>
            </div>
            <div class="line"></div>
            <div class="bannerRightBtns">
              <div class="bannerRightBtnList">
                <div class="" v-if="currentLanguage === 'en-US'">

                </div>
                <div :class="enBtnClass" v-else-if="isLogin">
                  <router-link :to="{ path: '/my', query: { type: 'ORDER', state: 0 } }">
                    <img src="../assets/images/myOrder.png" />
                    <div class="bannerBtnText">
                      {{ $t("components.index.btn_my_orders") }}
                    </div>
                  </router-link>
                </div>
                <div :class="enBtnClass" v-else>
                  <router-link to="/">
                    <img src="../assets/images/myOrder.png" />
                    <div class="bannerBtnText">
                      {{ $t("components.index.btn_my_orders") }}
                    </div>
                  </router-link>
                </div>

                <div :class="enBtnClass" v-if="isLogin">
                  <router-link :to="{ path: '/my', query: { type: 'COLLECTION' } }">
                    <img src="../assets/images/sc.png" />
                    <div class="bannerBtnText">
                      {{ $t("components.index.btn_my_collection") }}
                    </div>
                  </router-link>
                </div>
                <div :class="enBtnClass" v-else>
                  <router-link to="/">
                    <img src="../assets/images/sc.png" />
                    <div class="bannerBtnText">
                      {{ $t("components.index.btn_my_collection") }}
                    </div>
                  </router-link>
                </div>
              </div>
              <div div class="bannerRightBtnList">
                <div class="" v-if="currentLanguage === 'en-US'">

                </div>
                <div :class="enBtnClass" v-else-if="isLogin">
                  <router-link :to="{ path: '/my', query: { type: 'APPLYINVOICE' } }">
                    <img src="../assets/images/kpsc.png" />
                    <div class="bannerBtnText">
                      {{ $t("components.index.btn_invoice_manage") }}
                    </div>
                  </router-link>
                </div>
                <div :class="enBtnClass" v-else>
                  <router-link to="/">
                    <img src="../assets/images/kpsc.png" />
                    <div class="bannerBtnText">
                      {{ $t("components.index.btn_invoice_manage") }}
                    </div>
                  </router-link>
                </div>
                <div :class="enBtnClass">
                  <router-link to="/guide">
                    <img src="../assets/images/syzn.png" />
                    <div class="bannerBtnText">
                      {{ $t("components.index.btn_usage_guide") }}
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="line lineBottom"></div>
            <div class="swiper-container2">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in bannerList" :key="item.id">
                  <img :src="item.content" style="width: 190px; height: 120px" />
                </div>
              </div>
              <div class="swiper-pagination2"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-container0">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in advertList" :key="item.id">
            <img :src="item.content" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="sortList">
      <div class="sortProduct" v-for="(item, index) in hotcategoryList" :key="item.id">
        <router-link :to="{ path: '/category', query: { id: item.id } }">
          <img :src="item.content" class="proImg" />
          <div class="sortTitle">
            <span>{{ $t("components.index.more_details") }}</span>
            <img src="../assets/images/arrow1.png" />
          </div>
        </router-link>
      </div>
    </div>
    <div class="sellLists">
      <div class="sellListTitle">
        {{ $t("components.index.recommended_products") }}
      </div>
      <div class="sellList">
        <div class="sellPro" v-for="(item, index) in recommendproductList" :key="item.id">
          <router-link :to="{ path: '/detail', query: { id: item.id } }">
            <img :src="item.cover_image" class="proImg2" />
            <div class="sellProDetail">
              <div class="sellProTitle">{{ item.product_name }}</div>
              <div class="sellProText">{{ item.cate_name }}</div>
              <!-- <div class="sellProText2">评价：<span>5.0分</span></div> -->
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="proList" v-for="(item, index) in cateAndproList" :key="item.id">
      <img :src="item.content" class="actImg" />
      <div class="proTitle">
        <router-link :to="{ path: '/category', query: { id: item.id } }">{{
          item.name
        }}</router-link>
      </div>
      <div class="proTitleList">
        <div class="proTitleLi" v-for="(child, index) in item.child_list" :key="child.id">
          <router-link :to="{ path: '/category', query: { id: child.id } }">{{
            child.name
          }}</router-link>
        </div>
      </div>
      <div class="proTitleList">
        <div class="proTitleLi" v-for="(third, index) in item.third_list" :key="third.id">
          <router-link :to="{ path: '/category', query: { id: third.id } }">{{
            third.name
          }}</router-link>
        </div>
      </div>

      <div class="proLists">
        <div class="pro" v-for="(product, index) in item.product_list" :key="product.id">
          <router-link :to="{ path: '/detail', query: { id: product.id } }">
            <img :src="product.cover_image" class="proImg3" />
            <div class="proDetail">
              <div class="proDetialTitle">{{ product.product_name }}</div>
              <div class="proDetailText1">{{ product.cate_name }}</div>
              <!-- <div class="proDetailText2">评分：<span>5.0分</span></div> -->
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 最新消息 -->
    <div class="infoLists">
      <div class="newLists">
        <div class="newListTitle">
          <div class="newListTitleLeft">
            {{ $t("components.index.latest_info") }}
          </div>
          <router-link :to="{ path: '/infoList', query: { type: 'LATEST' } }">
            <div class="more">{{ $t("components.index.view_all") }}</div>
          </router-link>
        </div>

        <div class="infoli" v-for="(item, index) in latestArtList" :key="item.id">
          <router-link :to="{ path: '/info', query: { id: item.id } }">
            <div>{{ item.title }}</div>
            <div class="infoDate">{{ item.gmt_create }}</div>
          </router-link>
        </div>
      </div>
      <!-- 重要通知 -->
      <div class="notices">
        <div class="newListTitle">
          <div class="newListTitleLeft">
            {{ $t("components.index.important_notice") }}
          </div>
          <router-link :to="{ path: '/infoList', query: { type: 'IMPORTANT' } }">
            <div class="more">{{ $t("components.index.view_all") }}</div>
          </router-link>
        </div>
        <div class="infoli" v-for="(item, index) in importArtList" :key="item.id">
          <router-link :to="{ path: '/info', query: { id: item.id } }">
            <div>{{ item.title }}</div>
            <div class="infoDate">{{ item.gmt_create }}</div>
          </router-link>
        </div>
      </div>
    </div>

    <div class="fixedTool">
      <div class="fixedli" v-if="!isLogin">
        <router-link to="/login">
          <div class="fixedli">
            <img src="../assets/images/userBlack.png" class="iconBlack" />
            <img src="../assets/images/userWhite.png" class="iconWhite" />
            <div class="fixedText">
              {{ $t("components.index.fixed_login") }}
            </div>
          </div>
        </router-link>
      </div>
      <div class="fixedli" v-if="isLogin">
        <router-link to="/car">
          <div class="fixedli">
            <img src="../assets/images/carBlack.png" class="iconBlack" />
            <img src="../assets/images/carWhite.png" class="iconWhite" />
            <div class="fixedText">{{ $t("components.index.fixed_cart") }}</div>
          </div>
        </router-link>
      </div>
      <div class="fixedli" v-if="isLogin">
        <router-link :to="{ path: '/my', query: { type: 'COLLECTION' } }">
          <div class="fixedli">
            <img src="../assets/images/scBlack.png" class="iconBlack" />
            <img src="../assets/images/scWhite.png" class="iconWhite" />
            <div class="fixedText">
              {{ $t("components.index.fixed_collection") }}
            </div>
          </div>
        </router-link>
      </div>
      <div class="fixedli">
        <router-link to="/guide">
          <div class="fixedli">
            <img src="../assets/images/znBlack.png" class="iconBlack" />
            <img src="../assets/images/znWhite.png" class="iconWhite" />
            <div class="fixedText">
              {{ $t("components.index.fixed_guide") }}
            </div>
          </div>
        </router-link>
      </div>
      <div class="fixedli" @click="toNetService">
        <img src="../assets/images/kfBlack.png" class="iconBlack" />
        <img src="../assets/images/kfWhite.png" class="iconWhite" />
        <div class="fixedText">
          {{ $t("components.index.fixed_customer_service") }}
        </div>
      </div>
      <div class="fixedli" @click="scrollTop">
        <img src="../assets/images/backBlack.png" class="iconBlack" />
        <img src="../assets/images/backWhite.png" class="iconWhite" />
        <div class="fixedText">{{ $t("components.index.fixed_back") }}</div>
      </div>
    </div>
    <Foot2></Foot2>
  </div>
</template>

<script>
import Head2 from "../components/head2.vue";
import Foot2 from "../components/foot2.vue";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

import YSF from '@neysf/qiyu-web-sdk';

YSF.init('4da9494f8045c5b3c61de562974b136e');

export default {
  components: {
    Head2,
    Foot2,
  },
  data() {
    return {
      swiper1: null,
      swiper2: null,
      parentId: 0,
      categoryList: [],
      advtype: 10,
      advertList: [],
      bannerList: [],
      hotcategoryList: [],
      recommendproductList: [],
      cateAndproList: [],
      importArtList: [],
      latestArtList: [],
      isLogin: false,
      isShowMenu: false,
      childcategoryList: [],
      loginMember: {},
      currentLanguage: localStorage.getItem("locale-lang") || "zh-CN",
      enBtnClass: localStorage.getItem("locale-lang") === "en-US" ? "enBtn1" : "bannerBtn",
    };
  },
  created() {
    this.getCategoryInfo();
    this.getAdvertInfo();
    this.getBannerInfo();
    this.getHotCategoryInfo();
    this.getRecommendListInfo();
    this.getCateAndProListInfo();
    this.getLatestArticleInfo();
    this.getImportArticleInfo();
    this.checkLogin();
  },
  mounted() {
    const that = this;
    setTimeout(function () {
      if (localStorage.getItem("indexScrollTop")) {
        let scrollTopNum = localStorage.getItem("indexScrollTop");
        window.scrollTo(0, scrollTopNum);
      }
      window.addEventListener("scroll", that.handleScroll);
    }, 1000);
  },
  beforeDestroy() {
    localStorage.setItem("indexScrollTop", this.scrollTopNum);
    window.removeEventListener("scroll", this.handleScroll);
    //
    if (this.swiper1) {
      this.swiper1.destroy();
      this.swiper1 = null;
    }
  },
  methods: {
    toNetService() {
      window.open("https://ntlkltsbyxgs.qiyukf.com/client?k=4da9494f8045c5b3c61de562974b136e&wp=1&robotShuntSwitch=0&shuntId=0&templateId=8137935&language=zh-cn");
    },
    handleScroll() {
      this.scrollTopNum = document.documentElement.scrollTop;
    },
    scrollTop() {
      localStorage.removeItem("indexScrollTop");
      this.scrollTopNum = 0;
      window.scrollTo(0, 0);
    },
    initSwiper() {
      this.$nextTick(() => {
        this.swiper1 = new Swiper(".swiper-container0", {
          slidesPerView: 1,
          // 启用自动轮播
          autoplay: 60000,
          autoplayDisableOnInteraction: false,
          loop: true,
          pagination: ".swiper-pagination",
        });
      });
    },
    initSwiperBanner() {
      this.$nextTick(() => {
        this.swiper2 = new Swiper(".swiper-container2", {
          slidesPerView: 1,
          autoplay: 5000,
          autoplayDisableOnInteraction: false,
          loop: true,
          pagination: ".swiper-pagination2",
        });
      });
    },
    checkLogin() {
      this.$scUtil.checkLogin(this, (res) => {
        if (res) {
          //console.log(res);
          this.isLogin = true;
          this.GetMemberInfo();
        }
      });
    },
    GetMemberInfo() {
      this.$scUtil.axiosPost(
        this,
        "MemberApi/GetMemberInvoice",
        {
          userName: localStorage.getItem("username"),
        },
        (res) => {
          //console.log(res.code);
          if (res.code == 100) {
            this.loginMember = res.data;
            //console.log(JSON.stringify(this.memberInfo))
          }
        }
      );
    },
    getCategoryInfo() {
      this.$scUtil.axiosPost(
        this,
        "CategoryApi/GetCategoryListByParentId",
        {
          parentId: this.parentId,
        },
        (res) => {
          if (res.code == 100) {
            this.categoryList = res.data;
            //console.log(this.categoryList);
          }
        }
      );
    },
    getAdvertInfo() {
      this.$scUtil.axiosPost(
        this,
        "AdvertApi/GetAdvList",
        {
          advtype: this.advtype.toString(),
          count: 5,
        },
        (res) => {
          if (res.code == 100) {
            this.advertList = res.data;
            this.initSwiper();
            //console.log(this.advertList);
          }
        }
      );
    },
    getBannerInfo() {
      this.$scUtil.axiosPost(
        this,
        "AdvertApi/GetAdvList",
        {
          advtype: 2,
          count: 5,
        },
        (res) => {
          if (res.code == 100) {
            this.bannerList = res.data;
            this.initSwiperBanner();
            //console.log(this.advertList);
          }
        }
      );
    },
    getHotCategoryInfo() {
      this.$scUtil.axiosPost(
        this,
        "CategoryApi/GetHotCategory",
        {
          count: 5,
        },
        (res) => {
          if (res.code == 100) {
            this.hotcategoryList = res.data;
            //console.log(this.hotcategoryList);
          }
        }
      );
    },
    getRecommendListInfo() {
      this.$scUtil.axiosPost(
        this,
        "ProductApi/GetRecommendList",
        {
          cateId: "",
          count: 6,
        },
        (res) => {
          if (res.code == 100) {
            this.recommendproductList = res.data;
            //console.log(this.recommendproductList);
          }
        }
      );
    },
    getCateAndProListInfo() {
      this.$scUtil.axiosPost(
        this,
        "CategoryApi/GetCategoryAndProductList",
        {
          count: 6,
        },
        (res) => {
          if (res.code == 100) {
            this.cateAndproList = res.data;
            //console.log(this.cateAndproList);
          }
        }
      );
    },
    getLatestArticleInfo() {
      this.$scUtil.axiosPost(
        this,
        "ArticleApi/GetArticleListByType",
        {
          articleType: "normal",
          count: 6,
        },
        (res) => {
          if (res.code == 100) {
            res.data.forEach((item) => {
              item.gmt_create = this.$scUtil.dateFormatter(
                new Date(item.gmt_create),
                "Y/M/D"
              );
            });
            this.latestArtList = res.data;
            // console.log("最新消息", this.latestArtList);
          }
        }
      );
    },
    getImportArticleInfo() {
      this.$scUtil.axiosPost(
        this,
        "ArticleApi/GetArticleListByType",
        {
          articleType: "import",
          count: 6,
        },
        (res) => {
          if (res.code == 100) {
            res.data.forEach((item) => {
              item.gmt_create = this.$scUtil.dateFormatter(
                new Date(item.gmt_create),
                "Y/M/D"
              );
            });
            this.importArtList = res.data;
            // console.log("重要通知", this.importArtList);
          }
        }
      );
    },
    showMenu(id) {
      this.$scUtil.axiosPost(
        this,
        "CategoryApi/GetCategoryAndChlidrenByParentId",
        {
          parentId: id,
        },
        (res) => {
          if (res.code == 100) {
            this.childcategoryList = res.data;
            console.log(this.childcategoryList);
          }
        }
      );
      this.isShowMenu = true;
    },
    hideMenu() {
      this.isShowMenu = false;
    },
  },
};
</script>


<style scoped>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f3f3f3;
}

.prompt {
  width: 1200px;
  height: 83px;
  display: flex;
  align-items: center;
}

.promptInner {
  width: 1200px;
  height: 44px;
  border: 1px solid #0380fe;
  background-color: #fff;
  font-size: 13px;
  display: flex;
  align-items: center;
  padding: 0 17px;
  box-sizing: border-box;
}

.promptLink {
  color: #0380fe;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-color: #0380fe;
  margin-left: 20px;
  font-size: 13px;
}

.speakerIcon {
  margin-right: 13px;
}

.swiper-container0 {
  width: 99vw;
  overflow: hidden;
  position: relative;
}

.swiper-pagination {
  position: absolute;
  bottom: 15px;
}

.swiper-pagination .swiper-pagination-bullet {
  background-color: #6c6f6f;
  border: 1px solid #fff;
}

.swiper-pagination .swiper-pagination-bullet-active {
  background-color: #fff;
  border: 1px solid #fff;
}

.bannerArea {
  position: relative;
}

.bannerInnerLeft {
  border: 1px solid #0380fe;
  width: 210px;
  height: 463px;
  background-color: #fff;
  position: absolute;
  top: 0;
  z-index: 980;
}

.swiper-container0 .swiper-slide {
  display: flex;
  justify-content: center;
}

.bannerLeftTitle {
  width: 100%;
  height: 33px;
  background-color: #0380fe;
  color: #fff;
  font-size: 13px;
  text-align: center;
  line-height: 33px;
}

.bannerInnerMiddle {
  width: 772px;
}

.bannerRight {
  width: 220px;
  height: 463px;
  border: 1px solid #0380fe;
  background-color: #fff;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 980;
  display: flex;
  flex-direction: column;
}

.bannerInnerRight {
  width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  padding: 0 15px;
  box-sizing: border-box;
}

.dotIcon {
  margin-right: 16px;
  margin-left: 16px;
}

.bannerLeftLi {
  color: #333333;
  font-size: 13px;
  display: flex;
  align-items: center;
  height: 28px;
  cursor: pointer;
}

.bannerLeftLi:hover {
  background: #e0f0ff;
  color: #0380fe;
}

.bannerLeftLi:nth-child(1) {
  margin-top: 4px;
}

.headIcon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  margin-right: 15px;
}

.welcomeArea {
  display: flex;
  font-size: 13px;
  color: #888888;
  margin-top: 18px;
  justify-content: center;
  line-height: 20px;
  align-items: center;
}

.loginText {
  font-size: 13px;
  color: #888888;
  text-align: center;
  margin-top: 13px;
}

.loginText span {
  color: #0380fe;
  cursor: pointer;
}

.loginBtns {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}

.registerBtn {
  width: 92px;
  height: 32px;
  background: #0380fe;
  border: 1px solid #0380fe;
  color: #fff;
  font-size: 13px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  margin-right: 12px;
  cursor: pointer;
}

.loginBtn {
  width: 78px;
  height: 32px;
  border: 1px solid #0380fe;
  color: #0380fe;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}

.line {
  width: 191px;
  height: 1px;
  background-color: #dcdcdc;
  margin: 21px 0;
}

.bannerRightBtnList {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  width: 191px;
}

.bannerRightBtnList:nth-last-child(1) {
  margin-bottom: 0px;
}

.bannerBtn {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #000000;
  flex: 1;
  cursor: pointer;
}

.bannerBtn img {
  margin-left: 15px;
}

.bannerBtnText {
  font-size: 12px;
  margin-top: 10px;
}

.bannerRelative {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.swiper-container2 {
  width: 193px;
  overflow: hidden;
  position: relative;
}

.lineBottom {
  margin-bottom: 15px;
}

.swiper-pagination2 {
  position: absolute;
  bottom: 10px;
  right: 20px;
}

.swiper-pagination2 .swiper-pagination-bullet {
  background-color: transparent;
  border: 1px solid #fff;
}

.swiper-pagination2 .swiper-pagination-bullet-active {
  background-color: #fff;
  border: 1px solid #fff;
}

.sortList {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 1200px;
  margin-top: 13px;
}

.sortProduct {
  position: relative;
  margin-right: 10px;
}

.sortProduct:hover {
  cursor: pointer;
}

.sortProduct:nth-last-child(1) {
  margin-right: 0;
}

.sortTitle {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 232px;
  height: 32px;
  background-color: #0380fe;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  color: #fff;
  padding: 0 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 14px;
}

.proImg {
  width: 232px;
  height: 232px;
  border-radius: 8px;
}

.sellLists {
  width: 1200px;
  background: #fff;
  padding: 0 18px 21px 18px;
  box-sizing: border-box;
  margin-top: 16px;
}

.sellListTitle {
  font-size: 18px;
  color: #222222;
  height: 54px;
  line-height: 54px;
}

.sellList {
  display: flex;
  align-items: center;
}

.sellPro {
  width: 180px;
  height: 255px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  margin-right: 14px;
}

.sellPro:hover {
  cursor: pointer;
  border: 1px solid #0380fe;
}

.sellPro:nth-last-child(1) {
  margin-right: 0;
}

.proImg2 {
  width: 180px;
  height: 180px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.sellProDetail {
  padding: 0 13px;
  box-sizing: border-box;
  line-height: 21px;
}

.sellProTitle {
  color: #666;
  font-size: 12px;
  width: 159px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sellProText {
  font-size: 13px;
  width: 159px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333333;
}

.sellProText2 {
  font-size: 12px;
  color: #666666;
  width: 159px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sellProText2 span {
  color: #0380fe;
}

.actImg {
  width: 1200px;
  height: 83px;
  margin-top: 10px;
}

.proList {
  display: flex;
  flex-direction: column;
}

.proTitle {
  font-size: 18px;
  color: #000000;
  margin-top: 22px;
}

.proTitleList {
  display: flex;
  font-size: 13px;
  color: #333333;
  margin-top: 20px;
  margin-bottom: 15px;
  width: 1200px;
  overflow-x: auto;
}

.proTitleLi {
  padding: 0 11px;
  border-right: 1px solid #333;
  cursor: pointer;
  white-space: nowrap;
}

.proTitleLi:nth-child(1) {
  padding-left: 0;
}

.proTitleLi:nth-last-child(1) {
  border-right: 0px;
}

.proLists {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 1200px;
}

.pro {
  width: 229px;
  height: 261px;
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  background-color: #fff;
  margin: 0 11px 11px 0;
  cursor: pointer;
}

.pro a {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pro:nth-child(5n + 5) {
  margin-right: 0px;
}

.proImg3 {
  width: 156px;
  height: 156px;
  margin-top: 10px;
}

.proDetail {
  line-height: 24px;
  margin-top: 10px;
}

.proDetialTitle {
  font-size: 15px;
  color: #333333;
  text-align: center;
}

.proDetailText1 {
  font-size: 13px;
  color: #888888;
  text-align: center;
}

.proDetailText2 {
  font-size: 13px;
  color: #888888;
  text-align: center;
}

.proDetailText2 span {
  color: #0380fe;
}

.pro:hover {
  border: 1px solid #0380fe;
}

.infoLists {
  width: 1200px;
  background-color: #fff;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: flex-start;
  padding: 15px;
  box-sizing: border-box;
  margin-bottom: 15px;
}

.newLists {
  flex: 1;
  border-right: 1px solid #f3f3f3;
  padding-right: 19px;
  box-sizing: border-box;
}

.newListTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: bolder;
  color: #222;
  border-bottom: 1px solid #f3f3f3;
  padding-bottom: 22px;
}

.more {
  font-weight: normal;
  font-size: 13px;
  color: #0380fe;
  text-decoration: underline;
}

.newListTitleLeft {
  font-size: 18px;
  color: #222222;
}

.notices {
  flex: 1;
}

.infoli {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
  height: 56px;
  border-bottom: 1px dotted #f3f3f3;
  cursor: pointer;
}

.infoli:nth-last-child(1) {
  border-bottom: 0px;
}

.infoDate {
  color: #888888;
}

.notices {
  padding-left: 19px;
  box-sizing: border-box;
}

.fixedTool {
  width: 69px;
  position: fixed;
  top: 30%;
  right: 0;
  background-color: #fff;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  z-index: 1000;
}

.fixedli {
  width: 69px;
  height: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f3f3f3;
  cursor: pointer;
}

.fixedli:nth-last-child(1) {
  border-bottom: 0px;
}

.fixedText {
  font-size: 13px;
  color: #000000;
  margin-top: 5px;
}

.bannerInnerMiddle {
  position: absolute;
  left: 212px;
  top: 0;
  z-index: 980;
  background: #fff;
  width: 772px;
  height: 465px;
  font-size: 13px;
  color: #333333;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #0380fe;
}

.menuList {
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  align-items: baseline;
}

.menuList:hover {
  background: #e0f0ff;
}

.secondMenu {
  min-width: 109px;
}

.secondMenu span {
  min-width: 86px;
  text-align: left;
  display: inline-block;
}

.menuList ul {
  padding: 0 10px;
}

.menuList ul {
  display: flex;
  flex-wrap: wrap;
}

.menuList ul li {
  list-style: none;
  min-width: 94px;
  text-align: left;
  line-height: 25px;
}

.menuList:hover .secondMenu {
  color: #0380fe;
}

.rightTitle {
  background: rgba(0, 128, 255, 0.5);
  background: linear-gradient(to bottom, #a7d3ff, #d6eaff);
  font-size: 12px;
  width: 100%;
  height: 32px;
  text-align: center;
  line-height: 32px;
}

.welcomeText {
  margin-top: 10px;
}

.welcomeText,
.info_name {
  font-size: 12px;
  color: #0380fe;
  text-decoration: underline;
}

.info_phone {
  font-size: 14px;
  color: #000;
}

.safe {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #686868;
  margin-top: 10px;
}

.safeIcon {
  margin-right: 10px;
}

.safe span {
  margin-right: 10px;
}

.edit {
  cursor: pointer;
}

.iconWhite {
  display: none;
}

.fixedli:hover {
  background: #0380fe;
}

.fixedli:hover .iconBlack {
  display: none;
}

.fixedli:hover .iconWhite {
  display: initial;
}

.fixedli:hover .fixedText {
  color: #fff;
}

.dotActive {
  display: none;
  margin-right: 16px;
  margin-left: 16px;
}

.bannerLeftLi:hover .dotActive {
  display: initial;
}

.bannerLeftLi:hover .dotIcon {
  display: none;
}

.bannerBtn a {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.bannerBtn a .bannerBtnText {
  margin-top: 0px;
}


.enBtn1 {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: #000000;
  flex: 1;
  cursor: pointer;
  justify-content: left;
  align-items: initial;
}

.enBtn1 img {
  margin-left: 15px;
}

.enBtn1 a .bannerBtnText {
  margin-top: 0px;
}

.userInfoArea {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.router-link-active a,
.enBtn1 a {
  display: flex;
}
</style>
